function ScrollExecute() {
  if($('#more').length >0){
  if($('#more').offset().top-3000 < $(window).scrollTop()) {
   scrollNode = $('#more').last();    
   scrollURL = $('#more p a').last().attr("href");
   if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
       $.ajax({
           type: 'GET',
           url: scrollURL,
           beforeSend: function() {
               scrollNode.clone().empty().insertAfter(scrollNode).append('<img src=\"//cancelmeclothing.com/cdn/shop/t/37/assets/loader.gif?v=49802430826225972941793730800\" />');
               scrollNode.hide();
           },
           success: function(data) {
               scrollNode.next().remove();
               console.log($('#more p a',data).attr('href'));
             var nextLink = $('#more p a',data).attr('href');
               var filteredData = $(data).find(".product-grid").html();
             if(nextLink != undefined){
                $('#more p a').attr('href',nextLink);
             $('#more').show();
             }
               $(".appendProducts").append(filteredData);
               //filteredData.insertAfter( $(".appendProducts li:last-child") );  
console.log("test-customHulkAw-");         
  window.customHulkAw.init();
           },
           dataType: "html"
       });
   }
  }
  }  
}
  
  
  
  $(window).scroll(function(){

    // Added the code for search page Sticky type bar
   if( window.location.href.indexOf('/search') !== -1 ||  window.location.href.indexOf('/collections') !== -1 ) {
        var scroll = $(window).scrollTop();
        if (scroll >= 10) {
            $("body").addClass("top_scrolled scrolled");
             $(".collection-sidebar-menu-mobile").addClass("sticky_togglemenu");
           $(".desk_float_bar.page-width").addClass("desk_togglebar");
        $(".mainHomeTemp .colHeaderSection, .colHeaderSection").addClass("hide_on_scrolled");
        } else {
           $("body").removeClass("top_scrolled scrolled");
           $(".collection-sidebar-menu-mobile").removeClass("sticky_togglemenu");
            $(".desk_float_bar.page-width").removeClass("desk_togglebar");
         $(".mainHomeTemp .colHeaderSection, .colHeaderSection").removeClass("hide_on_scrolled");
           
        }
   }
// END CODE
    
   ScrollExecute();
  });
